import { TbArrowsLeftRight } from "react-icons/tb";

export const VoucherContextActions = ({ onTransfer }) => (
  <div className="cartoes-action-row">
    <button type="button" className="cartoes-action-btn" onClick={onTransfer}>
      <TbArrowsLeftRight className="h-3.5 w-3.5 shrink-0" />
      <span>Transferir</span>
    </button>
  </div>
);
